//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
import angular, { IHttpService } from 'angular';
import { IAbortablePromise, IPromiseService } from 'pinsights-js-shared';

import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import InstagramUserId from '@models/InstagramUserId';
import InstagramUsername from '@models/InstagramUsername';

const curalate = angular.module('curalate');

export interface IInstagramAccount {
  accountId: InstagramUserId;
  fullName?: string;
  profilePictureUrl?: string;
  username: InstagramUsername;
  website?: string;
  businessAccountId?: string;
}

export interface IInstagramSettings {
  accounts: IInstagramAccount[];
  hasLike2BuyStore: boolean;
  integrationStatus: {
    hasBusinessAccountMineable: boolean;
    hasBusinessAccountToken: boolean;
    hasRequiredInsightsPermissions: boolean;
    hasRequiredPublishPermissions: boolean;
  };
  like2BuyAccountId?: InstagramUserId;
  primaryAccountId?: InstagramUserId;
  primaryAccountTokenValid?: boolean;
}

export interface IGetInstagramAccountBusinessIdResponse {
  businessId: InstagramBusinessAccountId;
}

const BASE_URL = '/api/settings/instagram';

export class InstagramSettingsService {
  constructor(
    private readonly $http: IHttpService,
    private readonly PromiseService: IPromiseService,
  ) {}

  public getInstagramSettings(): IAbortablePromise<IInstagramSettings> {
    return this.PromiseService.processHttpResponse(this.$http.get(BASE_URL));
  }
  public getInstagramBusinessId(): IAbortablePromise<IGetInstagramAccountBusinessIdResponse> {
    return this.PromiseService.processHttpResponse(
      this.$http.get(`${BASE_URL}/account/business-id`),
    );
  }
}

curalate.service('InstagramSettingsService', [
  '$http',
  'PromiseService',
  InstagramSettingsService,
]);
